export const constructCategoriesDTO = (pointsList, categories, goods) => {
  const result = pointsList.map((point) => ({
    id: point.id,
    title: point.title || point.name || 'Point',
    categories: [],
  }));

  const pointsMap = new Map(result.map((p) => [p.id, p]));
  const categoryEntries = [];

  // Sort categories
  categories.sort(
    (a, b) => (a.categorySortNum || 0) - (b.categorySortNum || 0)
  );

  categories.forEach((cat) => {
    const point = pointsMap.get(cat.pointId);
    if (point) {
      const category = {
        ...cat,
        products: [],
      };

      point.categories.push(category);
      categoryEntries.push(category);
    }
  });

  goods.forEach((product) => {
    const category = product.categoryId
      ? categoryEntries.find((item) => String(item.id) === String(product.categoryId))
      : null;

    if (category) {
      category.products.push(product);
      return;
    }

    const pointId = product.pointId;
    const point = pointsMap.get(pointId);
    if (point) {
      let uncategorized = point.categories.find((c) => c.id === null);
      if (!uncategorized) {
        uncategorized = {
          pointId: point.id,
          name: 'ТОВАРЫ БЕЗ КАТЕГОРИЙ',
          id: null,
          isVisible: true,
          categorySortNum: 10000999,
          products: [],
        };
        point.categories.push(uncategorized);
      }
      uncategorized.products.push(product);
    }
  });

  // Re-sort to place "Uncategorized" correctly
  result.forEach((point) => {
    point.categories.sort(
      (a, b) => (a.categorySortNum || 0) - (b.categorySortNum || 0)
    );
  });

  return result;
};
